// src/pages/admin/library/LibraryLayout.tsx
import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import UIMessageProvider from '../../../components/common/UIMessageProvider';
import { 
  FaUsers, 
  FaBook, 
  FaList, 
  FaClipboardList,
  FaTachometerAlt,
  FaTrophy
} from '../../../utils/iconUtils';

const LibraryLayout: React.FC = () => {
  const location = useLocation();

  const tabs = [
    { id: 'dashboard', label: 'Dashboard', icon: FaTachometerAlt, path: '.', description: 'Library overview', end: true },
    { id: 'members', label: 'Members', icon: FaUsers, path: 'members', description: 'Manage library members' },
    { id: 'categories', label: 'Categories', icon: FaList, path: 'categories', description: 'Book categories' },
    { id: 'books', label: 'Books', icon: FaBook, path: 'books', description: 'Book inventory' },
    { id: 'attendance', label: 'Attendance', icon: FaClipboardList, path: 'attendance', description: 'Track visits' },
    { id: 'top-attendees', label: 'Top Attendees', icon: FaTrophy, path: 'top-attendees', description: 'Most active members' },
  ];

  return (
    <div className="space-y-4">
      {/* Header (compact) */}
      <div className="bg-white rounded-xl shadow-soft p-3">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
          <div>
            <h1 className="text-lg font-semibold text-gray-800">
              Library <span className="text-gray-500 text-sm mt-0.5">(Manage resources, members & attendance)</span>
            </h1>
          </div>
        </div>

        {/* Compact Tab Navigation */}
        <div className="mt-3">
          <div className="flex gap-2 overflow-x-auto whitespace-nowrap py-1">
            {tabs.map((tab) => (
              <NavLink
                key={tab.id}
                to={tab.path}
                 end={tab.end ?? false}
                className={({ isActive }) =>
                  `inline-flex items-center gap-2 px-3 py-2 rounded-md text-sm transition-all flex-shrink-0 ${
                    isActive
                      ? 'bg-primary-600 text-white shadow'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`
                }
              >
                <tab.icon className="h-4 w-4" />
                <div className="text-left">
                  <span className="font-medium text-sm leading-tight">{tab.label}</span>
                  <p className="text-xs opacity-70 hidden lg:block leading-tight">{tab.description}</p>
                </div>
              </NavLink>
            ))}
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className="min-h-[420px]">
        <UIMessageProvider>
          <Outlet />
        </UIMessageProvider>
      </div>
    </div>
  );
};

export default LibraryLayout;
